const StreetInsightsType = {
	SET_SELECTED_LOCATION: "SET_SELECTED_LOCATION",
	SET_LOCATION_HISTORY: "SET_LOCATION_HISTORY",
};

export default StreetInsightsType;
